export const ADP_USER = "adp_user";

export const setUserType = (isADP: boolean) => {
    localStorage.setItem(ADP_USER, `${isADP}`);
};

export const getUserType = () => {
    return localStorage.getItem(ADP_USER) === "true" ? true : false;
};

export const removeUserType = () => {
    return localStorage.removeItem(ADP_USER);
};

export const userLoggedIn = () => {
    return localStorage.getItem("isUserLoggedIn") === "true";
};
